import styled, { css } from 'styled-components';

import { mediaMixin, spaceMixin, Tabs, token } from '@zillow/constellation';
import { Link } from '@zg-rentals/zrs-comet';

export const StyledPageWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  min-height: 100vh;
  flex: 1 1 auto;
  max-width: 100%;
  width: 100%;
  background-color: ${token('colors.white')};
  border: 1px solid ${token('colors.gray300')};
`;

export const StyledTabsList = styled(Tabs.List)`
  button,
  button[aria-selected='true'] {
    && {
      padding: ${spaceMixin('sm')} ${spaceMixin('xs')};

      ${mediaMixin(
        'md',
        css`
          padding: ${spaceMixin('sm')};
        `,
      )};
    }
  }
`;

export const StyledLink = styled(Link)`
  && {
    color: ${({ selected }) => (selected ? token('colors.brand') : token('colors.black'))};
  }
`;
